import { Length } from "@siteimprove/alfa-css";
/**
 * Resolvers are functions that resolve values to their canonical, computed
 * representation.
 *
 * @internal
 */
export var Resolver;
(function (Resolver) {
    /**
     * Resolve a length in an arbitrary unit to a length in pixels.
     *
     * {@link https://drafts.csswg.org/css-values/#lengths}
     *
     * @remarks
     * Relative lengths in media queries are based on initial values of the
     * associated properties. They are hard-coded here to avoid circular dependency
     * to @siteimprove/alfa-style.
     */
    function length(device) {
        const { viewport } = device;
        const width = Length.of(viewport.width, "px");
        const height = Length.of(viewport.height, "px");
        const fontSize = Length.of(16, "px");
        const rootFontSize = Length.of(16, "px");
        return { length: Length.resolver(fontSize, rootFontSize, width, height) };
    }
    Resolver.length = length;
})(Resolver || (Resolver = {}));
//# sourceMappingURL=resolver.js.map